export enum LoginStep {
    Login = 'login',
    Captcha = 'captcha',
    OtpMethod = 'otpMethod',
    OtpVerify = 'otpVerify',
    ForgottenPassReset = 'forgottenPassReset',
    ForgottenPassNewPass = 'forgottenPassNewPass',
    ForgottenPassSuccessful = 'forgottenPassSuccessful',
}
